import { City } from 'src/types'

export enum CitiesActionTypes {
  GET_CITIES = '@cities/GET_CITIES',
  GET_CITIES_FAILURE = '@cities/GET_CITIES_FAILURE',
  GET_CITIES_SUCCESS = '@cities/GET_CITIES_SUCCESS'
}

export type CitiesState = {
  readonly error: boolean
  readonly list: City[]
  readonly loading: boolean
}
